import PageContainerBlank from '../../components/PageContainer/PageContainerBlank.js';
import PageEndBlank from '../../components/PageContainer/PageEndBlank.js';
import PrayerInstructions from '../../components/PrayerInstructions/PrayerInstructions.js';
import SimpleImage from '../../components/SimpleImage/SimpleImage';
import FlexColumn from '../../components/FlexColumn/FlexColumn.js';

const HolyNameChaplet = () => {
	const instructions = [
		{imageKey: "crucifix", title: "Make the Sign of the Cross", descriptionElements: (
			<div>
				<p>Our help is in the Name of the Lord, who made Heaven and Earth.</p>
			</div>
		)},
		{imageKey: "", title: "Act of Contrition", descriptionElements: (
			<div>
				<p>O my God, I am heartily sorry for having offended Thee; I detest all my sins because I dread the loss of heaven and the pains of hell, but most of all because they offend Thee, my God, Who art all good and deserving of all my love. I firmly resolve, with the help of Thy grace, to sin no more and to avoid the near occasions of sin.</p>
				<p>Amen.</p>
			</div>
		)},
		{imageKey: "", title: "Lord, help me", descriptionElements: (
			<div>
				<p>Incline unto my aid, O God.<br />O Lord, make haste to help me.</p>
			</div>
		)},
		{imageKey: "largebead", title: "Jesus, You said...", descriptionElements: (
			<div>
				<p>Jesus, You said <strong>"ask and you will receive, seek and you will find, knock and the door will be opened."</strong> Jesus, I ask, I seek, I knock in Your great Name for these favors:</p>
				<em className='highlight'>(State your intentions)</em>
			</div>
		)},
		{imageKey: "smallbead", title: "Lord, help me", descriptionElements: (
			<div>
				<em className='highlight'>(Pray for each of the 10 beads in the decade)</em>
			</div>
		)},
		{imageKey: "largebead", title: "Jesus, You said...", descriptionElements: (
			<div>
				<p>Jesus, You said <strong>"ask anything of Me in My Name, I will do it."</strong> It is of the Father and in Your Name, Lord, I ask for these intentions.</p>
			</div>
		)},
		{imageKey: "smallbead", title: "Lord, help me", descriptionElements: (
			<div>
				<em className='highlight'>(Pray for each of the 10 beads in the decade)</em>
			</div>
		)},
		{imageKey: "largebead", title: "Jesus, You said...", descriptionElements: (
			<div>
				<p>Jesus, You said <strong>"Heaven and Earth will pass away, but My word will not pass away."</strong> Grant me these favors because You have said it and it is true.</p>
			</div>
		)},
		{imageKey: "smallbead", title: "Lord, help me", descriptionElements: (
			<div>
				<em className='highlight'>(Pray for each of the 10 beads in the decade)</em>
			</div>
		)},
		{imageKey: "medallion", title: "Closing Prayer", descriptionElements: (
			<div>
				<p>Blessed be the Name of the Lord, now and forever.</p>
				<em className='highlight'>(Pray this three times)</em>
			</div>
		)},
		{imageKey: "crucifix", title: "Make the Sign of the Cross", descriptionElements: (<div></div>)},
	];
	return (
		<div className='justify'>
			<PageContainerBlank />

			<h1>Holy Name Chaplet</h1>
			<p className='centered'>The Holy Name Chaplet is prayed on a 33 bead chaplet, not a rosary.</p>
			<FlexColumn>
				<SimpleImage style={{ maxWidth: '300px' }} src="https://upload.wikimedia.org/wikipedia/commons/9/9b/Full_length_negatives_of_the_shroud_of_Turin.jpg" alt="The Shroud of Turin" width="2370px" height="2321px" />
			</FlexColumn>
			<br />

			<PrayerInstructions instructions={instructions} />

			<PageEndBlank />
		</div>
	);
};

export default HolyNameChaplet;